// export const API_URL = 'http://localhost:8100'
// export const API_URL = 'https://profile-analyst-f876008b7510.herokuapp.com'

export const API_URL = process.env.VUE_APP_API_URL